function openPopUpGuiaTallas(
    product,
    tableTallas,
    corte,
    recommendations,
    defaultTab = "tabla",
) {
    let titleElement = document.getElementById("guia-tallas-title");
    let corteElement = document.getElementById("guia-tallas-corte");
    let tableElement = document.getElementById("guia-tallas-table");
    let recomendationElement = document.getElementById("recomendation-table");
    let footerElement = document.getElementById("guia-tallas-footer");

    titleElement.textContent = product.title;
    corteElement.textContent = corte;

    let guiaTallas = document.querySelector(".guia-tallas-overlay");
    let guiaTallasContainer = document.querySelector(".guia-tallas");
    if (guiaTallas) {
        guiaTallas.classList.add("active");
        guiaTallasContainer.classList.add("active");
    }

    const guiaTallasTabla = createGuiaTallas(tableTallas);
    tableElement.innerHTML = ""; // Limpiar contenido previo
    tableElement.appendChild(guiaTallasTabla);

    const recomendationTable = createTablaRecomendaciones(recommendations);
    if (recomendationTable) {
        recomendationElement.innerHTML = ""; // Limpiar contenido previo
        recomendationElement.appendChild(recomendationTable);
    }

    const contactButton = createContactButton(product.title);
    footerElement.innerHTML = ""; // Limpiar contenido previo
    footerElement.appendChild(contactButton);

    changeButtonTables();

    // Activar pestaña inicial
    let tableButton = document.getElementById("tableButton");
    let recomendationsBtn = document.getElementById("recomendationsBtn");
    if (defaultTab === "recomendaciones") {
        recomendationsBtn.click();
    } else {
        tableButton.click();
    }
}

function closePopUpGuiaTallas() {
    let guiaTallas = document.querySelector(".guia-tallas-overlay");
    let guiaTallasContainer = document.querySelector(".guia-tallas");
    if (guiaTallas) {
        guiaTallas.classList.remove("active");
        guiaTallasContainer.classList.remove("active");
    }
}

function handleOpenPopUpGuiaTallas(button, defaultTab) {
    const productData = JSON.parse(button.getAttribute("data-product"));
    const tableTallas = JSON.parse(button.getAttribute("data-table-tallas"));
    const recommendations = JSON.parse(
        button.getAttribute("data-recomendations"),
    );
    const corte = button.getAttribute("data-corte");
    openPopUpGuiaTallas(
        productData,
        tableTallas,
        corte,
        recommendations,
        defaultTab,
    );
}

function createGuiaTallas(size_table) {
    // Creamos la tabla
    const table = document.createElement("table");
    table.id = "sizeTable";

    // Crear thead
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    size_table.headers.forEach((header, index) => {
        const th = document.createElement("th");
        th.classList.add("text-center");

        const button = document.createElement("button");
        button.type = "button";
        button.classList.add("table-size-btn");

        // Si es el primero, ocultarlo
        if (index === 0) {
            button.style.display = "none";
        }

        const span = document.createElement("span");
        span.dataset.noActivator = ""; // equivale a data-no-activator=""
        span.textContent = header;

        button.appendChild(span);
        th.appendChild(button);
        headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Crear tbody
    const tbody = document.createElement("tbody");

    size_table.rows.forEach((row) => {
        const tr = document.createElement("tr");

        const firstTd = document.createElement("td");
        firstTd.classList.add("first-td");
        firstTd.textContent = row.label;
        tr.appendChild(firstTd);

        row.values.forEach((value) => {
            const td = document.createElement("td");
            td.textContent = value;
            tr.appendChild(td);
        });

        tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    return table;
}

function createTablaRecomendaciones(recommendations) {
    if (!recommendations) return;

    const fragment = document.createDocumentFragment();

    recommendations.forEach((item) => {
        const div = document.createElement("div");
        div.className = "recomendation-item";

        // Título = talla
        const title = document.createElement("span");
        title.className = "recomendation-item-title";
        title.textContent = item.talla;
        div.appendChild(title);

        // Contenedor datos extra
        const content = document.createElement("div");
        content.className = "recomendation-item-content";

        Object.entries(item).forEach(([key, value]) => {
            if (key !== "talla") {
                const p = document.createElement("p");

                // Capitalizar primera letra y mantener el resto igual
                const label = key.charAt(0).toUpperCase() + key.slice(1);

                p.innerHTML = `${label}: <span>${value}</span>`;
                content.appendChild(p);
            }
        });

        div.appendChild(content);
        fragment.appendChild(div);
    });

    return fragment;
}

function createContactButton(productName) {
    const button = document.createElement("a");
    button.className = "guia-tallas-contact-button";
    button.textContent = "Habla con un especialista";
    button.target = "_blank";
    button.rel = "noopener noreferrer";

    // Crea el mensaje y lo codifica para URL
    const message = `Hola necesito más información del ${productName}`;
    const encodedMessage = encodeURIComponent(message);

    // Asigna el href con el mensaje codificado
    button.href = `https://wa.me/524777294477?text=${encodedMessage}`;

    return button;
}

function changeButtonTables() {
    let selectBtn = document.querySelectorAll(".table-sizes-select-btn");
    let tableButton = document.getElementById("tableButton");
    let recomendationsBtn = document.getElementById("recomendationsBtn");

    let tableContainer = document.getElementById("guia-tallas-table");
    let recomendationContainer = document.getElementById("recomendation-table");

    // Agregar los listeners una sola vez
    recomendationsBtn.addEventListener("click", function () {
        tableContainer.style.display = "none";
        recomendationContainer.style.display = "flex";
        selectBtn.forEach((btn) => btn.classList.remove("bg-black"));
        recomendationsBtn.classList.add("bg-black");
    });

    tableButton.addEventListener("click", function () {
        tableContainer.style.display = "flex";
        recomendationContainer.style.display = "none";
        selectBtn.forEach((btn) => btn.classList.remove("bg-black"));
        tableButton.classList.add("bg-black");
    });

    // Listener solo para cambiar la clase activa
    selectBtn.forEach((button) => {
        button.addEventListener("click", function () {
            selectBtn.forEach((btn) => btn.classList.remove("bg-black"));
            this.classList.add("bg-black");
        });
    });
}

function handleOpenPopUpGuiaMedidas(button) {
    const productDataTitle = button.getAttribute("data-product-title");
    const medidasImg = button.getAttribute("data-medidas");
    openPopUpMedidas(productDataTitle, medidasImg);
}

function openPopUpMedidas(productDataTitle, medidasImg) {
    let titleElement = document.getElementById("guia-medidas-title");
    let footerElement = document.getElementById("guia-medidas-footer");
    let imgContainer = document.getElementById("guia-medidas-image");

    titleElement.textContent = productDataTitle;

    const imgElement = document.createElement("img");
    imgElement.src = medidasImg;
    imgContainer.innerHTML = "";
    imgContainer.appendChild(imgElement);

    let guiaMedidas = document.querySelector(".guia-medidas-overlay");
    let guiaMedidasContainer = document.querySelector(".guia-medidas");
    if (guiaMedidas) {
        guiaMedidas.classList.add("active");
        guiaMedidasContainer.classList.add("active");
    }

    const contactButton = createContactButton(productDataTitle);
    footerElement.innerHTML = "";
    footerElement.appendChild(contactButton);
}

function closePopUpGuiaMedidas() {
    let guiaMedidas = document.querySelector(".guia-medidas-overlay");
    let guiaMedidasContainer = document.querySelector(".guia-medidas");
    if (guiaMedidas) {
        guiaMedidas.classList.remove("active");
        guiaMedidasContainer.classList.remove("active");
    }
}

function handleOpenPopUpMaterial(button) {
    let productDataMaterial = button.getAttribute("data-product-material");
    openPopUpMaterial(productDataMaterial);
}

function openPopUpMaterial(productDataMaterial) {
    console.log(productDataMaterial);
    let titleElement = document.getElementById("popup-material-title");
    let contentElement = document.getElementById("popup-material-content");

    titleElement.textContent = productDataMaterial;

    const borregoText = `<img src="https://cdn.shopify.com/s/files/1/3004/6046/files/borrego_1.png?v=1769471526"/>
    <p>La piel de borrego es reconocida por su suavidad, ligereza y flexibilidad natural. Se adapta al cuerpo desde el primer uso, ofreciendo una sensación cómoda y un ajuste más preciso con el tiempo. Gracias a sus propiedades naturales, ayuda a conservar el calor en climas fríos y se mantiene fresca cuando la temperatura sube, haciendo la prenda cómoda durante todo el año. Por su grano fino, es ideal para prendas que buscan elegancia, movimiento y uso diario sin rigidez.</p> <p>Beneficios clave</p>
    <ul>
      <li>Extra suave al tacto</li>
      <li>Ligera y flexible</li>
      <li>Regulación térmica natural</li>
      <li>Mejora su apariencia con el uso</li>
    </ul>
    `;
    const bovinoText = `<img src="https://cdn.shopify.com/s/files/1/3004/6046/files/bovino_1.png?v=1769471526"/>
    <p>La piel bovina premium es reconocida por su resistencia, estructura y carácter natural. Es una piel más firme, diseñada para acompañarte en el uso diario y mantener su forma con el paso del tiempo. Con el uso, la piel desarrolla una pátina natural: el color se vuelve más profundo, el tacto más suave y la superficie adquiere matices únicos que hacen que cada pieza sea distinta. Gracias a su grano natural y grosor, es ideal para bolsas, duffle y accesorios que buscan durabilidad sin sacrificar estética.</p>

    <p>Beneficios clave</p>
    <ul>
      <li>Estructura firme y resistente</li>
      <li>Mantiene su forma y estructura</li>
      <li>Desarrolla pátina con el tiempo</li>
      <li>Ideal para accesorios duraderos</li>
    </ul>
    <p>Una piel pensada para durar años y verse mejor con cada uso</p>`;

    if (productDataMaterial.includes("borrego")) {
        contentElement.innerHTML = borregoText;
    } else if (
        productDataMaterial.includes("bovino") ||
        productDataMaterial.includes("becerro")
    ) {
        contentElement.innerHTML = bovinoText;
    } else {
        contentElement.textContent = "Material no especificado.";
    }

    let popupMaterial = document.querySelector(".popup-material-overlay");
    let popupMaterialContainer = document.querySelector(".popup-material");
    if (popupMaterial) {
        popupMaterial.classList.add("active");
        popupMaterialContainer.classList.add("active");
    }
}

function closePopUpMaterial() {
    let popupMaterial = document.querySelector(".popup-material-overlay");
    let popupMaterialContainer = document.querySelector(".popup-material");
    if (popupMaterial) {
        popupMaterial.classList.remove("active");
        popupMaterialContainer.classList.remove("active");
    }
}
